import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=4aec8604"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports